import { SetStateAction, useEffect, useRef, useState } from "react";
import { Player, PlayerState } from 'video-react';
import { NavLink } from "react-router-dom";

type VideoData = {
    options: VideoOption[],
    name: string,
    color: "light" | "dark",
    thumbnail: string // 960x1200
}

type VideoOption = {
    path: string,
    type: string
}

function Projekte() {
    const [currrentVideo, setCurrentVideo] = useState<VideoData>();
    const [videoData, setVideoData] = useState<VideoData[]>();
    const showVideo = (video: VideoData) => setCurrentVideo(video);

    useEffect(() => {
        window.fetch(process.env.PUBLIC_URL + "/videos/videos.json")
            .then(async response => {
                if (response.ok) {
                    const data = await response.json()
                    if (data) setVideoData(data)
                }
            })
            .catch(() => { })
    }, [])

    return <main className="projekte content-box">
        <VideoModal video={currrentVideo} setVideo={setCurrentVideo} />
        <div>
            <p>Jeder Film erfüllt eine Aufgabe – <b>Aufmerksamkeit</b> schaffen, <b>Emotionen</b> wecken oder <b>Inhalte</b> klar vermitteln. Hier findest du eine Auswahl meiner Arbeiten aus verschiedenen Bereichen.</p>
        </div>
        <VideoPreviewContainer videoData={videoData} handleShowVideo={showVideo} />
        <div className="cta">
            <span>Gerfällt dir, was du siehst?</span>
            <NavLink className="button" to="/kontakt">Lass uns Dein Projekt umsetzen!</NavLink>
        </div>
    </main>
}

function VideoPreviewContainer(props: {
    videoData?: VideoData[],
    handleShowVideo: (video: VideoData) => void
}) {
    return <div className="preview-container">
        {props.videoData?.map(v =>
            <div key={v.name} className={"preview " + v.color}>
                <div className="thumbnail" style={{ backgroundImage: `url(${v.thumbnail})` }} onClick={() => props.handleShowVideo(v)}>
                    <button>
                        <span>Film ansehen</span>
                        <span className="ti-control-play" />
                    </button>
                </div>
            </div>
        )}
    </div>
}

function VideoModal(props: {
    video?: VideoData,
    setVideo: React.Dispatch<SetStateAction<VideoData | undefined>>
}) {
    const videoRef = useRef<any>(null);
    const modalRef = useRef<HTMLDivElement>(null);
    const [state, setState] = useState<PlayerState>();
    const [videoSize, setVideoSize] = useState<{ x: number, y: number }>()
    const handleClose = () => props.setVideo(undefined);

    useEffect(() => {
        const video = videoRef.current;
        if (video && props.video) {
            video.load();
            return () => video.pause();
        }
    }, [props.video]);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.subscribeToStateChange(handleStateChange);
            videoRef.current.video.disablePictureInPicture = true;
            videoRef.current.video.video.disablePictureInPicture = true;
        }
    }, []);

    useEffect(() => {
        if (state && modalRef.current) {
            const factor = Math.min(modalRef.current.clientWidth / state.videoWidth, modalRef.current.clientHeight / state.videoHeight);
            setVideoSize({
                x: state.videoWidth * factor,
                y: state.videoHeight * factor
            });
        }
    }, [state, state?.videoWidth, state?.videoHeight, modalRef.current?.clientWidth, modalRef.current?.clientHeight])

    function handleStateChange(current: PlayerState, previous: PlayerState) {
        setState(current);
    }

    return <div className={props.video ? "modal" : "modal closed"} ref={modalRef}>
        <div style={{ width: videoSize?.x, height: videoSize?.y, position: 'relative' }}>
            <button className="modal-close" onClick={handleClose}>
                <span className="ti-close" />
            </button>
            <Player ref={videoRef} autoPlay poster={props.video?.thumbnail}>
                {props.video?.options.map(option =>
                    <source key={option.type} src={option.path} type={option.type} />
                )}
            </Player>
        </div>
    </div>
}

export default Projekte;